import React, { useEffect, useState, useRef } from "react";
import "./StressTest.scss";
import ReactHtmlParser from "react-html-parser";
import useReturnNavigation from "../../hooks/useReturnNavigation";
import HnwHomeButton from "../../common/hnwHomeButton/HnwHomeButton";
import {
    loadStressAssessmentData,
    sortStressQuestions,
    buildStressAnswerData,
    submitStressAssessmentAnswer,
    getStressResult,
    preloadImage,
    stressSex,
    stressAge,
} from "./StressTest.service";

function StressTest() {
    useReturnNavigation();
    const [showPersonalPage, setShowPersonalPage] = useState(false);
    const [selectedSex, setSelectedSex] = useState("");
    const [selectedAge, setSelectedAge] = useState("");
    const [accepted, setAccepted] = useState(false);
    const [assessmentData, setAssessmentData] = useState(null);
    const [tcData, setTCData] = useState(null);
    const [showTC, setShowTC] = useState(false);
    const [fontReady, setFontReady] = useState(false);
    const [bannerReady, setBannerReady] = useState(false);
    const [started, setStarted] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [isAnswering, setIsAnswering] = useState(false);
    const [resultScore, setResultScore] = useState(null);
    const [showResult, setShowResult] = useState(false);
    const [showBreakPage, setShowBreakPage] = useState(false);
    const [pendingQuestion, setPendingQuestion] = useState(null);
    const [hasHistory, setHasHistory] = useState(false);
    const [historyList, setHistoryList] = useState([]);
    const [selectedHistory, setSelectedHistory] = useState(0);
    const [open, setOpen] = useState(false);

    const [stickerPos, setStickerPos] = useState({
        x: window.innerWidth - 140,
        y: window.innerHeight - 200,
    });
    const [showSticker, setShowSticker] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [personalLoaded, setPersonalLoaded] = useState(false);

    const breakContent = {
        5: {
            pic: "/images/stress/stresstest_break5.png",
            title: (
                <>
                    การรับรู้ความรู้สึกของตัวเอง... <br />
                    คือจุดเริ่มต้นของการดูแลใจ
                </>
            ),
            desc: "คุณทำได้ดีแล้ว ไปกันต่อเลย",
        },
        15: {
            pic: "/images/stress/stresstest_break15.png",
            title: (
                <>
                    คุณทำได้ดีมาก
                    <br />
                    ใกล้ครบทุกข้อแล้ว
                </>
            ),
            desc: "อีกนิดเดียว",
        },
    };

    const currentBreak = breakContent[pendingQuestion];

    const questions = sortStressQuestions(assessmentData);
    const question = questions[currentQuestion];

    const progress = questions.length
        ? Math.round(((showBreakPage ? pendingQuestion : currentQuestion) / questions.length) * 100)
        : 0;

    const result = resultScore !== null
        ? getStressResult(resultScore, assessmentData)
        : null;

    const handleStart = () => {
        if (!accepted) return;

        const customer = JSON.parse(
            sessionStorage.getItem("customer") || "null"
        );

        const isAnonymous =
            !customer ||
            customer?.type == null ||
            customer.type === "public";

        if (isAnonymous) {
            const latestHistory = [...historyList].sort(
                (a, b) =>
                    new Date(b.createdDate) - new Date(a.createdDate)
            )[0];

            setSelectedSex(latestHistory?.sex || "");
            setSelectedAge(latestHistory?.age || "");

            setPersonalLoaded(
                Boolean(latestHistory?.sex && latestHistory?.age)
            );

            setShowPersonalPage(true);

            return;
        }

        setShowPersonalPage(false);
        setStarted(true);
    };

    const handleStartQuestion = () => {
        if (!selectedSex || !selectedAge) return;

        setShowPersonalPage(false);
        setStarted(true);
    };
    const handlePersonalBack = () => {
        setShowPersonalPage(false);
    };

    const handleBack = () => {
        if (currentQuestion > 0) {
            setShowBreakPage(false);
            setCurrentQuestion(prev => prev - 1);
        } else {
            setStarted(false);
        }
    };

    const reloadData = async () => {
        try {
            const { assessment, tc, logHistory, hasHistory } =
                await loadStressAssessmentData();

            setHistoryList(logHistory);
            setHasHistory(hasHistory);

            if (hasHistory) {
                setAccepted(true);
            }

            setAssessmentData(assessment);
            setTCData(tc);
        } catch (error) {
            console.error(error);
        }
    };

    const resetAssessment = async () => {
        setStarted(false);
        setShowResult(false);
        setCurrentQuestion(0);
        setAnswers([]);
        setResultScore(null);
        setShowBreakPage(false);
        setPendingQuestion(null);
        setShowSticker(false);

        setSelectedSex("");
        setSelectedAge("");
        setShowResult(false);
        setCurrentQuestion(0);
        await reloadData();
    };

    const retryAssessment = () => {
        setShowResult(false);
        setCurrentQuestion(0);
        setAnswers([]);
        setResultScore(null);
        setShowBreakPage(false);
        setPendingQuestion(null);
        setShowSticker(false);
        setSelectedSex("");
        setSelectedAge("");


        const customer = JSON.parse(
            sessionStorage.getItem("customer") || "null"
        );

        if (!customer || customer?.type == null || customer.type === "public") {
            const latestHistory = [...historyList].sort(
                (a, b) =>
                    new Date(b.createdDate) - new Date(a.createdDate)
            )[0];

            setSelectedSex(latestHistory?.sex || "");
            setSelectedAge(latestHistory?.age || "");
            setStarted(false);

            setPersonalLoaded(
                Boolean(latestHistory?.sex && latestHistory?.age)
            );

            setShowPersonalPage(true);

            return;
        }

        setStarted(true);

    };

    const submitStressAssessment = async (answerList) => {
        try {
            const { totalScore, logHistory } = await submitStressAssessmentAnswer(
                assessmentData?._id,
                answerList,
                selectedSex,
                selectedAge
            );

            setResultScore(totalScore);
            setHistoryList(logHistory || []);
            setHasHistory((logHistory || []).length > 0);
            setSelectedHistory(0);
            setShowResult(true);
            setShowSticker(true);
        } catch (error) {
            console.error(error);
        }
    };

    const answeringRef = useRef(false);

    const handleAnswer = async (answer) => {
        if (answeringRef.current || !question) return;

        answeringRef.current = true;

        setSelectedAnswer(answer.value);
        setIsAnswering(true);

        const answerData = buildStressAnswerData(question, answer);

        const newAnswers = [
            ...answers.filter(item => item.question_id !== question._id),
            answerData,
        ];

        setAnswers(newAnswers);

        setTimeout(async () => {
            setSelectedAnswer(null);
            setIsAnswering(false);

            const nextQuestion = currentQuestion + 1;

            if (nextQuestion < questions.length) {
                const breakQuestions = [5, 15];

                if (breakQuestions.includes(nextQuestion)) {
                    setPendingQuestion(nextQuestion);
                    setShowBreakPage(true);
                    answeringRef.current = false;
                    // return;
                }

                setCurrentQuestion(nextQuestion);
                answeringRef.current = false;
            } else {
                await submitStressAssessment(newAnswers);
                answeringRef.current = false;
            }
        }, 300);
    };

    const handleStickerPointerDown = (e) => {
        e.preventDefault();

        const startX = e.clientX;
        const startY = e.clientY;
        const initialX = stickerPos.x;
        const initialY = stickerPos.y;

        let moved = false;

        const move = (ev) => {
            moved = true;
            setIsDragging(true);

            const size = 100;

            let x = initialX + (ev.clientX - startX);
            let y = initialY + (ev.clientY - startY);

            x = Math.max(0, Math.min(window.innerWidth - size, x));
            y = Math.max(0, Math.min(window.innerHeight - size, y));

            setStickerPos({ x, y });
        };

        const up = () => {
            window.removeEventListener("pointermove", move);
            window.removeEventListener("pointerup", up);

            setTimeout(() => {
                setIsDragging(false);
            }, 50);
        };

        window.addEventListener("pointermove", move);
        window.addEventListener("pointerup", up);
    };

    useEffect(() => {
        let mounted = true;

        const waitFont = async () => {
            try {
                if (document.fonts) {
                    await Promise.race([
                        document.fonts.ready,
                        new Promise(resolve => setTimeout(resolve, 1000)),
                    ]);
                }
            } catch (error) {
                console.error(error);
            } finally {
                if (mounted) setFontReady(true);
            }
        };

        waitFont();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        reloadData();
    }, []);

    useEffect(() => {
        if (!assessmentData?.landing_image_url) return;

        const bannerUrl = `${process.env.REACT_APP_S3_URL}${assessmentData.landing_image_url}`;

        preloadImage(bannerUrl).finally(() => {
            setBannerReady(true);
        });
    }, [assessmentData]);

    useEffect(() => {
        if (!selectedSex || !selectedAge || personalLoaded) return;

        const timer = setTimeout(() => {
            handleStartQuestion();
        }, 300);

        return () => clearTimeout(timer);
    }, [selectedSex, selectedAge, personalLoaded]);

    useEffect(() => {
        const customer = JSON.parse(
            sessionStorage.getItem("customer") || "null"
        );

        const isAnonymous =
            !customer ||
            customer?.type == null ||
            customer.type === "public";

    }, []);

    const cleanHtmlContent = (html) => {
        if (!html) return "";
        try {
            const doc = new DOMParser().parseFromString(html, "text/html");
            return doc.body.innerHTML;
        } catch {
            return html;
        }
    };

    if (!fontReady || !assessmentData || !tcData || !bannerReady) {
        return (
            <div className="StressTest">
                <div className="stressHome">
                    <HnwHomeButton />
                    <img
                        className="stressTopDecor"
                        src="/images/stress/stresstest_main_1.png"
                        alt=""
                    />

                    <div className="stressGreeting">
                        <div className="stressSkeleton stressSkelGreetingTitle" />
                        <div className="stressSkeleton stressSkelGreetingSub" />
                    </div>

                    <section className="stressBanner">
                        <div className="stressSkeleton stressSkelBanner" />
                    </section>

                    <section className="stressSkeletonInfoCard">
                        <div className="stressInfoText">
                            <div className="stressSkeleton stressSkelInfoTitle" />
                            <div className="stressSkeleton stressSkelInfoLine" />
                            <div className="stressSkeleton stressSkelInfoLine" />
                        </div>

                        <div className="stressSkeleton stressSkelChart" />
                    </section>

                    <section className="stressSkeletonDmhCard">
                        <div className="stressSkeleton stressSkelDmhLogo" />

                        <div className="stressDmhText">
                            <div className="stressSkeleton stressSkelDmhTitle" />
                            <div className="stressSkeleton stressSkelDmhLine" />
                            <div className="stressSkeleton stressSkelDmhLine short" />
                        </div>
                    </section>

                    <section className="stressSkeletonNote">
                        <div className="stressSkeleton stressSkelNoteLine" />
                        <div className="stressSkeleton stressSkelNoteLine" />
                        <div className="stressSkeleton stressSkelNoteLine short" />
                    </section>

                    <div className="stressBottom">
                        <div className="stressSkelAcceptRow">
                            <div className="stressSkeleton stressSkelCheck" />
                            <div className="stressSkeleton stressSkelAcceptText" />
                        </div>

                        <div className="stressSkeleton stressSkelButton" />
                    </div>
                </div>
            </div>
        );
    }



    return (
        <div className="StressTest">
            {showResult ? (
                <div className={`stressResultPage `}>
                    <div className="resultTitle">
                        ผลการประเมินและวิเคราะห์ความเครียด
                    </div>

                    {hasHistory && historyList.length > 0 && (
                        <div className="stressHistorySelectWrap">
                            <div className="dropdown">
                                <button
                                    type="button"
                                    className="dropdown__header"
                                    onClick={() => setOpen(!open)}
                                >
                                    <span>{historyList?.[selectedHistory]?.createdDate}</span>
                                    <span className={`arrow ${open ? "open" : ""}`} />
                                </button>

                                {open && (
                                    <div className="dropdown__list">
                                        {historyList.map((item, index) => (
                                            <div
                                                key={index}
                                                className="dropdown__item"
                                                onClick={() => {
                                                    setSelectedHistory(index);
                                                    setResultScore(item?.result || 0);
                                                    setOpen(false);
                                                }}
                                            >
                                                {item.createdDate}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {result && (
                        <>
                            <img
                                className="resultFace"
                                src={result.image}
                                alt=""
                            />

                            <div className="resultScoreCard">
                                <div className="resultScoreText">
                                    <span>คะแนน</span>
                                    <strong className={`resultScoreTextCol ${result.className}`}>
                                        {resultScore}
                                    </strong>
                                </div>

                                <div className={`resultArrow ${result.className}`} />
                            </div>

                            <div className={`resultDetailCard ${result.className}`}>
                                <h3>{result.level}</h3>
                                <h4>{result.range}</h4>
                                <p>{ReactHtmlParser(cleanHtmlContent(result.desc))}</p>
                            </div>
                        </>
                    )}

                    <div className="resultBottom">
                        <button
                            type="button"
                            className="resultHomeBtn"
                            onClick={resetAssessment}
                        >
                            กลับสู่หน้าหลัก
                        </button>

                        <button
                            type="button"
                            className="resultRetryBtn"
                            onClick={retryAssessment}
                        >
                            ทำแบบประเมินใหม่
                        </button>
                    </div>
                </div>
            ) : showPersonalPage ? (
                <div className="stressPersonalPage">
                    <div className="stressPersonalContent">

                        <section className="stressPersonalSection">
                            <h2>คุณคือเพศใด?</h2>

                            <div className="stressSexGroup">
                                {stressSex.map(item => (
                                    <button
                                        key={item.key}
                                        type="button"
                                        className={`stressPersonalOption ${selectedSex === item.key ? 'selected' : ''
                                            }`}
                                        onClick={() => {
                                            setPersonalLoaded(false);
                                            setSelectedSex(item.key);
                                        }}
                                    >
                                        <img
                                            src={`/images/stress/${item.key}.png`}
                                            alt={item.label}
                                            className={`stressPersonalIcon${item.key}`}
                                        />

                                        <span>{item.label}</span>
                                    </button>
                                ))}
                            </div>
                        </section>

                        <section className="stressPersonalSection">
                            <h2>คุณอายุเท่าไหร่?</h2>

                            <div className="stressAgeGroup">
                                {stressAge.map(item => (
                                    <button
                                        key={item.key}
                                        type="button"
                                        className={`stressPersonalOption ${selectedAge === item.key ? 'selected' : ''
                                            }`}
                                        onClick={() => {
                                            setPersonalLoaded(false);
                                            setSelectedAge(item.key);
                                        }}
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                        </section>


                    </div>

                    <div className="questionFooter stressPersonalFooter">
                        <button
                            type="button"
                            className="backBtn"
                            onClick={handlePersonalBack}
                        >
                            <span>←</span>
                        </button>

                        <div className="progressWrap">
                            <div className="progressBar">
                                <div
                                    className="progressFill"
                                    style={{ width: "0%" }}
                                />
                            </div>

                            <span>0%</span>
                        </div>
                    </div>
                </div>
            ) : !started ? (
                <div className={`stressHome`}>
                    <HnwHomeButton />
                    <img
                        className="stressTopDecor"
                        src="/images/stress/stresstest_main_1.png"
                        alt=""
                    />

                    <div className="stressGreeting">
                        <h1>สวัสดีค่ะ</h1>
                        <p>วันนี้คุณรู้สึกเป็นอย่างไร?</p>
                    </div>

                    <section className="stressBanner">
                        {assessmentData?.landing_image_url && (
                            <img
                                className="stressBannerFullImg"
                                src={`${process.env.REACT_APP_S3_URL}${assessmentData?.landing_image_url}`}
                                alt="Stress Banner"
                            />
                        )}
                    </section>

                    <section className="stressDmhCard">
                        <div className="stressInfoText">
                            {ReactHtmlParser(cleanHtmlContent(assessmentData?.metaData?.full_description))}
                        </div>

                        <img
                            className="stressChartImg"
                            src="/images/stress/stresstest_main_4.png"
                            alt=""
                        />
                    </section>

                    <section className="stressInfoCard">
                        <img
                            className="stressDmhLogo"
                            src="/images/stress/stresstest_main_3.png"
                            alt="กรมสุขภาพจิต"
                        />

                        <div className="stressDmhText">
                            <h3>{ReactHtmlParser(cleanHtmlContent(assessmentData?.title))}</h3>
                            <p>{ReactHtmlParser(cleanHtmlContent(assessmentData?.metaData?.short_description))}</p>

                        </div>
                    </section>

                    <section className="stressNote">
                        {ReactHtmlParser(cleanHtmlContent(assessmentData?.metaData?.remarks))}
                    </section>

                    <div className="stressBottom">
                        {!hasHistory ? (
                            <>
                                <label className="stressAccept">
                                    <input
                                        type="checkbox"
                                        checked={accepted}
                                        onChange={(e) => setAccepted(e.target.checked)}
                                    />

                                    <span className="stressCheck" />

                                    <span
                                        className="stressAcceptText"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowTC(true);
                                        }}
                                    >
                                        ยอมรับเงื่อนไขการทำแบบประเมินความเครียด
                                    </span>
                                </label>

                                <button
                                    type="button"
                                    className={`stressStartBtn ${accepted ? "active" : ""}`}
                                    disabled={!accepted}
                                    onClick={handleStart}
                                >
                                    เริ่มทำแบบประเมิน <span>→</span>
                                </button>
                            </>
                        ) : (
                            <>
                                <button
                                    type="button"
                                    className="stressStartBtn active"
                                    onClick={handleStart}
                                >
                                    เริ่มทำแบบประเมิน <span>→</span>
                                </button>

                                <button
                                    type="button"
                                    className="stressHistoryBtn"
                                    onClick={() => {
                                        const item = historyList[0];

                                        setSelectedHistory(0);
                                        setResultScore(item?.result || 0);
                                        setShowSticker(true);
                                        setShowResult(true);
                                    }}
                                >
                                    ดูประวัติการทำแบบประเมิน
                                </button>
                            </>
                        )}
                    </div>
                </div>
            ) : showBreakPage ? (
                <div className={`stressBreakPage`}>

                    <img
                        className="stressBreakImage"
                        src={currentBreak?.pic}
                        alt=""
                    />

                    <h2>ผ่านไปแล้ว {currentQuestion} ข้อ</h2>

                    <h3>{currentBreak?.title}</h3>

                    <p>{currentBreak?.desc}</p>

                    <button
                        type="button"
                        className="stressBreakBtn"
                        onClick={() => setShowBreakPage(false)}
                    >
                        ไปต่อนะ →
                    </button>

                    <div className="questionFooter">
                        <button
                            type="button"
                            className="backBtn"
                            onClick={handleBack}
                        >
                            <span>←</span>
                        </button>

                        <div className="progressWrap">
                            <div className="progressBar">
                                <div
                                    className="progressFill"
                                    style={{ width: `${progress}%` }}
                                />
                            </div>

                            <span>{progress}%</span>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={`stressQuestionPage`}>
                    {question?.image_url && (
                        <img
                            className="questionImage"
                            src={`${process.env.REACT_APP_S3_URL}${question.image_url}`}
                            alt={question.question}
                        />
                    )}

                    <h2>คำถามที่ {question?.display_order}</h2>

                    <h3>{ReactHtmlParser(cleanHtmlContent(question?.question))}</h3>

                    <p>{ReactHtmlParser(cleanHtmlContent(question?.description))}</p>

                    <div className="answerGroup">
                        <button
                            type="button"
                            className={selectedAnswer === 3 ? "selected" : ""}
                            onClick={() => !isAnswering && handleAnswer({ text: "เป็นประจำ", value: 3 })}
                        >
                            เป็นประจำ
                        </button>

                        <button
                            type="button"
                            className={selectedAnswer === 2 ? "selected" : ""}
                            onClick={() => !isAnswering && handleAnswer({ text: "ค่อนข้างบ่อย", value: 2 })}
                        >
                            ค่อนข้างบ่อย
                        </button>

                        <button
                            type="button"
                            className={selectedAnswer === 1 ? "selected" : ""}
                            onClick={() => !isAnswering && handleAnswer({ text: "ครั้งคราว", value: 1 })}
                        >
                            ครั้งคราว
                        </button>

                        <button
                            type="button"
                            className={selectedAnswer === 0 ? "selected" : ""}
                            onClick={() => !isAnswering && handleAnswer({ text: "ไม่เลย", value: 0 })}
                        >
                            ไม่เลย
                        </button>
                    </div>

                    <div className="questionFooter">
                        <button
                            type="button"
                            className="backBtn"
                            onClick={handleBack}
                        >
                            <span>←</span>
                        </button>

                        <div className="progressWrap">
                            <div className="progressBar">
                                <div
                                    className="progressFill"
                                    style={{ width: `${progress}%` }}
                                />
                            </div>

                            <span>{progress}%</span>
                        </div>
                    </div>
                </div>
            )}

            {showTC && (
                <div
                    className="stressTcOverlay"
                    onClick={() => setShowTC(false)}
                >
                    <div
                        className="stressTcModal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="stressTcHandle" />

                        <div className="stressTcContent">
                            {ReactHtmlParser(cleanHtmlContent(tcData?.data?.content))}
                        </div>

                        <button
                            type="button"
                            className="stressTcAcceptBtn"
                            onClick={() => {
                                setAccepted(true);
                                setShowTC(false);
                            }}
                        >
                            ยอมรับเงื่อนไข
                        </button>
                    </div>
                </div>
            )}

            {showSticker && (
                <div
                    className="stressFloatingSticker"
                    style={{
                        left: `${stickerPos.x}px`,
                        top: `${stickerPos.y}px`,
                    }}
                    onPointerDown={handleStickerPointerDown}
                    onClick={() => {
                        window.open(assessmentData?.metaData?.redirectURL, "_blank");
                    }}
                >
                    <button
                        type="button"
                        aria-label="close"
                        className="stressFloatingStickerClose"
                        onPointerDown={(e) => e.stopPropagation()}
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowSticker(false);
                        }}
                    />

                    <img
                        src="/images/stress/stresstest_heart.png"
                        alt=""
                    />
                </div>
            )}
        </div>
    );
}

export default StressTest;